<template>
  <div>
    <div
      v-if="categorized_images.length && categorized_images[0].category"
    >
      <CollapsableCategory
        v-for="(item, i) in categorized_image_links"
        :key="`gallery${i}-category${item.category}`"
        :description="description || item.category"
        :color="foreground_color"
        :init_expanded="true"
      >
        <template #content="{ is_collapsed, }">
          <TransitionAccordion>
            <Gallery
              v-if="!is_collapsed"
              :image_links="item.images"
              :id="`gallery${i}`"
              :border_radius="5"
              @emittedClick="$emit('emittedClick', $event)"
            />
          </TransitionAccordion>
        </template>
      </CollapsableCategory>
    </div>

    <Gallery
      v-else
      :image_links="all_image_links"
      :id="'gallery1'"
      :border_radius="5"
      @emittedClick="$emit('emittedClick', $event)"
    />
  </div>
</template>

<script>
import CollapsableCategory from '@/components/WorkPackageWIP/CollapsableCategory.component.vue';
import Gallery from '@/components/WorkPackageWIP/Gallery.component.vue';
import TransitionAccordion from '@/components/WorkPackageWIP/TransitionAccordion.component.vue';

  export default {
    components: {
      CollapsableCategory,
      Gallery,
      TransitionAccordion,
    },

    props: [
      'description', // is description for dropdown, only use this for hard description
      'categorized_images', // is array of objects, contains description, step, date, person (string)
      'background_color', // is string, contains hexadecimal value of background
      'foreground_color', // is string, contains hexadecimal value of text, outlines etc.
    ],

    computed: {
      all_image_links() {
        let img_links = [];
        for(let i = 0; i < this.categorized_images.length; i++) {
          for(let j = 0; j < this.categorized_images[i].data.length; j++) {
            img_links.push(this.categorized_images[i].data[j].image);
          }
        }
        return img_links;
      },

      categorized_image_links() {
        let img_links = [];
        for(let i = 0; i < this.categorized_images.length; i++) {
          img_links.push({
            category: this.categorized_images[i].category,
            images: []
          });
          for(let j = 0; j < this.categorized_images[i].data.length; j++) {
            img_links[i].images.push(this.categorized_images[i].data[j].image);
          }
        }
        return img_links;
      },
    },

    data: () => ({

    }),

    methods: {

    },
  }
</script>

<style>

</style>
